import React, { createContext, useContext, useState,useEffect } from "react";

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const[role, setRole] = useState('');

  const[state, setState] = useState({ idToken:null, accessToken:null, email:null, 
    patientId:null, 
    providerId:null,
    awsCreds:null,
    user:null,
    patientInfo:null,
    doctorInfo:null });
  
  //const role = 'doctor'; //user?.role || null;

  const isDoctor = role === "doctor";

  const isPatient = role?.toLowerCase() === "patient";

  useEffect(() => {
    console.log("User role in AppProvider setuer changes:", user?.role);
  }, [user]);

  const value = {
    user,
    setUser,
    setRole,
    isAuthenticated,
    setIsAuthenticated,
    role,
    isDoctor,
    isPatient,
    state,
    setState,
    patientId: state?.patientId,
    providerId: state?.providerId,
    awsCreds: state?.awsCreds,
    setPatientInfo: (patientInfo) => setState((prevState) => ({ ...prevState, patientInfo })),
    setDoctorInfo: (doctorInfo) => setState((prevState) => ({ ...prevState, doctorInfo })),
  };


  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);

  if (!context) {
    throw new Error("useAppContext must be used inside AppProvider");
  }

  return context;
};